import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  GET_SERIES_ESCOLA,
  ADD_SERIES_ESCOLA,
  UPDATE_SERIES_ESCOLA,
  DELETE_SERIES_ESCOLA,
  LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA,
  LISTA_SERIES_POR_CURSO_SERIES_ESCOLA,
  LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA,
  BUSCA_SERIES_ESCOLA_EDICAO,
  GET_COMPONENTES_SERIE_PADRAO
} from '../constants/ActionTypes';
import {
  getSeriesEscolaSuccess,
  addSeriesEscolaSuccess,
  updateSeriesEscolaSuccess,
  deleteSeriesEscolaSuccess,
  listaCursosPorEscolaSeriesEscolaSuccess,
  listaSeriesPorCursoSeriesEscolaSuccess,
  listaAnosLetivosPorCursoSeriesEscolaSuccess,
  buscaSeriesEscolaEdicaoSuccess,
  getComponentesSeriePadraoSuccess,
  showLoader,
  hideLoader,
  showMessage,
  showSuccessMessage
} from '../actions/SeriesEscola';
import api from '../util/Api';

const getSeriesEscolaRequest = async (filter) => {

  return await api.get('series_escola', { params: filter })
    .then(res => res.data)
    .catch(error => error);
}

const addSeriesEscolaRequest = async (data) => {
  return await api.post('series_escola', data)
    .then(res => res.data)
    .catch(error => error);
}

const updateSeriesEscolaRequest = async (data) => {
  return await api.put(`series_escola/${data.id}`, data)
    .then(res => res.data)
    .catch(error => error);
}

const deleteSeriesEscolaRequest = async (id) => {
  return await api.delete(`series_escola/${id}`)
    .then(res => res.data)
    .catch(error => error);
}

const getCursosDaEscola = async (idEscola) =>
  await api.get(`/escolas/${idEscola}/cursos`)
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
  await api.get(`/series?CursoId=${cursoId}`)
    .then(resposta => resposta)
    .catch(error => error);

const getTodosCursos = async () =>
  await api.get('/cursos')
    .then(resposta => resposta)
    .catch(error => error);

const getAnosLetivosPorCurso = async (id) =>
  await api.get(`/cursos/${id}/anos-letivos-iniciados`)
    .then(resposta => resposta)
    .catch(error => error);

const getSeriesEscolaEdicaoRequest = async (id) =>
  await api.get(`series_escola/${id}`)
    .then(resposta => resposta)
    .catch(error => error);

const getComponentesSeriePadraoRequest = async (serieId) =>
  await api.get(`series/${serieId}/componentes`)
    .then(resposta => resposta)
    .catch(error => error);

function* fnGetComponentesSeriePadrao({ payload }) {
  try {
    const { serieId } = payload;
    const retorno = yield call(getComponentesSeriePadraoRequest, serieId);
    if (retorno.message) {
      yield put(showMessage(retorno.message));
    } else {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (data && data.componentes ? data.componentes : []);
      yield put(getComponentesSeriePadraoSuccess(lista));
    }
  } catch (error) {
    yield put(showMessage('Erro ao buscar componentes da série padrão'));
  }
}

function* getSeriesEscola({ payload }) {
  try {
    const data = yield call(getSeriesEscolaRequest, payload);
    if (data.message) {
      yield put(showMessage(data.message));
    } else {
      yield put(getSeriesEscolaSuccess(data));
    }
  } catch (error) {
    yield put(showMessage('Erro ao buscar séries da escola'));
  }
}

function* addSeriesEscola({ payload }) {
  try {
    const data = yield call(addSeriesEscolaRequest, payload);
    if (data.message) {
      const status = data?.response?.status;
      const responseData = data?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = responseData?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (responseData && typeof responseData === 'object') {
          mensagemValidacao = responseData.mensagem || JSON.stringify(responseData);
        }
        yield put(showMessage(mensagemValidacao || data.message));
      } else {
        yield put(showMessage(data.message));
      }
    } else {
      yield put(addSeriesEscolaSuccess(data));
      yield put(showSuccessMessage('seriesEscola.sucessoCadastro'));
    }
  } catch (error) {
    yield put(showMessage('Erro ao cadastrar série da escola'));
  }
}

function* updateSeriesEscola({ payload }) {
  try {
    const data = yield call(updateSeriesEscolaRequest, payload);
    if (data.message) {
      const status = data?.response?.status;
      const responseData = data?.response?.data;
      if (status === 400) {
        let mensagemValidacao = '';
        let inconsistencias = responseData?.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
          mensagemValidacao = inconsistencias[0].mensagem;
        } else if (responseData && typeof responseData === 'object') {
          mensagemValidacao = responseData.mensagem || JSON.stringify(responseData);
        }
        yield put(showMessage(mensagemValidacao || data.message));
      } else {
        yield put(showMessage(data.message));
      }
    } else {
      yield put(updateSeriesEscolaSuccess(data));
      yield put(showSuccessMessage('seriesEscola.sucessoAtualizacao'));
    }
  } catch (error) {
    yield put(showMessage('Erro ao atualizar série da escola'));
  }
}

function* deleteSeriesEscola({ payload }) {
  try {
    const data = yield call(deleteSeriesEscolaRequest, payload);
    if (data.message) {
      yield put(showMessage(data.message));
    } else {
      yield put(deleteSeriesEscolaSuccess(payload));
      yield put(showSuccessMessage('seriesEscola.sucessoExclusao'));
    }
  } catch (error) {
    yield put(showMessage('Erro ao remover série da escola'));
  }
}

function* fnListaCursosPorEscolaSeriesEscola({ payload }) {
  try {
    const escolaId = payload?.escolaId || 0;
    if (!escolaId || Number(escolaId) === 0) {
      yield put(listaCursosPorEscolaSeriesEscolaSuccess([]));
      return;
    }
    const retorno = yield call(getCursosDaEscola, escolaId);
    if (retorno.message) {
      yield put(showMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      let lista = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));

      // Normalização inicial para garantir id e nome se vierem campos diferentes
      lista = lista.map(item => {
        if (typeof item === 'object') {
          const id = item.id || item.Id || item.cursoId || item.CursoId;
          const nome = item.nome || item.Nome || item.descricao || item.Descricao || item.titulo || item.Titulo || item.nomeCurso || item.NomeCurso;
          return { ...item, id, nome: nome || item.nome };
        }
        return item;
      });

      // Enriquecimento de nomes se necessário (lógica copiada de Turma.js para manter consistência)
      const precisaEnriquecer = Array.isArray(lista) && lista.some(item => {
        if (typeof item !== 'object') return true;
        const nome = item.nome || item.Nome || item.descricao || item.Descricao || item.titulo || item.Titulo || item.nomeCurso || item.NomeCurso || item.descricaoCurso || item.DescricaoCurso;
        return !nome;
      });

      if (precisaEnriquecer) {
        const retTodos = yield call(getTodosCursos);
        if (!retTodos.message && retTodos.data) {
          const todosRaw = retTodos.data;
          const todos = Array.isArray(todosRaw) ? todosRaw : (Array.isArray(todosRaw?.curso) ? todosRaw.curso : (Array.isArray(todosRaw?.Curso) ? todosRaw.Curso : []));
          const mapa = new Map(todos.map(c => [(c.id || c.Id), (c.nome || c.Nome || c.descricao || c.Descricao)]));
          lista = lista.map(item => {
            if (typeof item === 'object') {
              const idItem = item.id || item.Id || item.cursoId || item.CursoId;
              const nomeItem = item.nome || item.Nome || item.descricao || item.Descricao || item.titulo || item.Titulo || item.nomeCurso || item.NomeCurso || item.descricaoCurso || item.DescricaoCurso;
              if (!nomeItem) {
                const nome = mapa.get(idItem) || String(idItem);
                return { ...item, id: idItem, nome };
              }
              // Garante que o objeto tenha a propriedade id normalizada
              return { ...item, id: idItem || item.id };
            }
            const nome = mapa.get(item) || String(item);
            return { id: item, nome };
          });
        }
      }

      yield put(listaCursosPorEscolaSeriesEscolaSuccess(lista));

      if (!lista || lista.length === 0) {
        yield put(showMessage('seriesEscola.erroSemCursos'));
      }
    }
  } catch (error) {
    yield put(showMessage(JSON.stringify(error)));
  }
}

function* fnListaSeriesPorCursoSeriesEscola({ payload }) {
  try {
    const cursoId = payload?.cursoId || 0;
    if (!cursoId || Number(cursoId) === 0) {
      yield put(listaSeriesPorCursoSeriesEscolaSuccess([]));
      return;
    }
    const retorno = yield call(getSeriesPorCurso, cursoId);
    if (retorno.message) {
      yield put(showMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : (Array.isArray(data?.Series) ? data.Series : []));
      yield put(listaSeriesPorCursoSeriesEscolaSuccess(lista));
      if (!lista || lista.length === 0) {
        yield put(showMessage('seriesEscola.erroSemSeries'));
      }
    }
  } catch (error) {
    yield put(showMessage(JSON.stringify(error)));
  }
}

function* fnListaAnosLetivosPorCursoSeriesEscola({ payload }) {
  try {
    const cursoId = payload?.cursoId || 0;
    if (!cursoId || Number(cursoId) === 0) {
      yield put(listaAnosLetivosPorCursoSeriesEscolaSuccess([]));
      return;
    }
    const retorno = yield call(getAnosLetivosPorCurso, cursoId);
    if (retorno.message) {
      yield put(showMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      const rawLista = Array.isArray(data) ? data : (Array.isArray(data?.anosLetivos) ? data.anosLetivos : []);
      // Normalização para { id, title } para consistência com reducers/sagas de Curso.js
      const lista = rawLista.map(ano => ({
        id: typeof ano === 'object' ? (ano.id || ano.ano) : Number(ano),
        title: String(typeof ano === 'object' ? (ano.title || ano.ano || ano.id) : ano)
      }));
      yield put(listaAnosLetivosPorCursoSeriesEscolaSuccess(lista));
      if (!lista || lista.length === 0) {
        yield put(showMessage('seriesEscola.erroSemAnosLetivos'));
      }
    }
  } catch (error) {
    yield put(showMessage(JSON.stringify(error)));
  }
}

function* fnBuscaSeriesEscolaEdicao({ payload }) {
  try {
    const id = payload;
    const retorno = yield call(getSeriesEscolaEdicaoRequest, id);
    if (retorno.message) {
      yield put(showMessage(retorno.message));
    } else {
      const data = retorno.data;
      yield put(buscaSeriesEscolaEdicaoSuccess(data));
    }
  } catch (error) {
    yield put(showMessage('Erro ao buscar série da escola para edição'));
  }
}

export function* watchGetSeriesEscola() {
  yield takeEvery(GET_SERIES_ESCOLA, getSeriesEscola);
}

export function* watchAddSeriesEscola() {
  yield takeEvery(ADD_SERIES_ESCOLA, addSeriesEscola);
}

export function* watchUpdateSeriesEscola() {
  yield takeEvery(UPDATE_SERIES_ESCOLA, updateSeriesEscola);
}

export function* watchDeleteSeriesEscola() {
  yield takeEvery(DELETE_SERIES_ESCOLA, deleteSeriesEscola);
}

export function* watchListaCursosPorEscola() {
  yield takeEvery(LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA, fnListaCursosPorEscolaSeriesEscola);
}

export function* watchListaSeriesPorCurso() {
  yield takeEvery(LISTA_SERIES_POR_CURSO_SERIES_ESCOLA, fnListaSeriesPorCursoSeriesEscola);
}

export function* watchListaAnosLetivosPorCurso() {
  yield takeEvery(LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA, fnListaAnosLetivosPorCursoSeriesEscola);
}

export function* watchBuscaSeriesEscolaEdicao() {
  yield takeEvery(BUSCA_SERIES_ESCOLA_EDICAO, fnBuscaSeriesEscolaEdicao);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetSeriesEscola),
    fork(watchAddSeriesEscola),
    fork(watchUpdateSeriesEscola),
    fork(watchDeleteSeriesEscola),
    fork(watchListaCursosPorEscola),
    fork(watchListaSeriesPorCurso),
    fork(watchListaAnosLetivosPorCurso),
    fork(watchBuscaSeriesEscolaEdicao)
  ]);
}
